const ROWS = [
  { marca: "B150", bc: "Bc 10",   clasa: "C 8/10",  fckCil: "8",   fckCub: "10" },
  { marca: "B200", bc: "Bc 15",   clasa: "C 12/15", fckCil: "12",  fckCub: "15" },
  { marca: "B250", bc: "Bc 20",   clasa: "C 16/20", fckCil: "16",  fckCub: "20" },
  { marca: "B330", bc: "Bc 25",   clasa: "C 20/25", fckCil: "20",  fckCub: "25" },
  { marca: "B400", bc: "Bc 30",   clasa: "C 25/30", fckCil: "25",  fckCub: "30" },
  { marca: "B450", bc: "Bc 35",   clasa: "C 28/35", fckCil: "28",  fckCub: "35" },
  { marca: "—",    bc: "—",      clasa: "C 30/37", fckCil: "30",  fckCub: "37" },
  { marca: "B500", bc: "Bc 40",   clasa: "C 32/40", fckCil: "32",  fckCub: "40" },
  { marca: "—",    bc: "—",      clasa: "C 35/45", fckCil: "35",  fckCub: "45" },
  { marca: "B600", bc: "Bc 50",   clasa: "C 40/50", fckCil: "40",  fckCub: "50" },
  { marca: "—",    bc: "—",      clasa: "C 45/55", fckCil: "45",  fckCub: "55" },
  { marca: "B700", bc: "Bc 60",   clasa: "C 50/60", fckCil: "50",  fckCub: "60" },
];

export default function Services() {
  return (
    <section id="beton" data-testid="services-section" className="py-20 sm:py-32 bg-white border-t border-black/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#F59E0B] mb-6">
              · 02 / TIPURI BETON
            </div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tight">
              Echivalența<br />
              <span className="text-[#F59E0B]">Marcă & Clasă</span><br />
              de Beton
            </h2>
          </div>
          <p className="max-w-md text-sm sm:text-base text-neutral-700 leading-relaxed">
            Conform <span className="font-mono-tech font-bold">C140-86</span> și{" "}
            <span className="font-mono-tech font-bold">NE 012-99</span>. Prețuri și
            disponibilitate stabilite telefonic — sunați la{" "}
            <a href="tel:0766693105" className="font-bold text-black underline underline-offset-4 decoration-[#F59E0B] decoration-2 whitespace-nowrap">
              Fetești · 0766 693 105
            </a>{" "}
            sau{" "}
            <a href="tel:0722569492" className="font-bold text-black underline underline-offset-4 decoration-[#F59E0B] decoration-2 whitespace-nowrap">
              Slobozia · 0722 569 492
            </a>{" "}
            între orele 08:00 - 17:00.
          </p>
        </div>

        {/* Table — desktop */}
        <div data-testid="services-table" className="hidden md:block overflow-hidden border border-black/15">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[#0A0A0A] text-white">
                <Th>Marcă beton<br /><span className="opacity-60 font-normal">conf. C40/79</span></Th>
                <Th>Clasă beton<br /><span className="opacity-60 font-normal">conf. C140-86</span></Th>
                <Th highlight>Clasă rezistență<br /><span className="opacity-80 font-normal">conf. NE 12/99</span></Th>
                <Th>Fck cilindru<br /><span className="opacity-60 font-normal">(N/mm²)</span></Th>
                <Th>Fck cub<br /><span className="opacity-60 font-normal">(N/mm²)</span></Th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr
                  key={i}
                  data-testid={`row-${r.clasa.replace(/[\s/]/g, "-")}`}
                  className={`${i % 2 === 0 ? "bg-white" : "bg-[#FAFAFA]"} hover:bg-[#FFF7E6] transition-colors border-t border-black/10`}
                >
                  <Td>{r.marca}</Td>
                  <Td>{r.bc}</Td>
                  <Td highlight>{r.clasa}</Td>
                  <Td mono>{r.fckCil}</Td>
                  <Td mono>{r.fckCub}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cards — mobile */}
        <div className="md:hidden grid grid-cols-1 gap-3">
          {ROWS.map((r, i) => (
            <div
              key={i}
              data-testid={`card-${r.clasa.replace(/[\s/]/g, "-")}`}
              className="border border-black/15 bg-white"
            >
              <div className="bg-[#F59E0B] text-black px-4 py-3 flex items-center justify-between">
                <span className="font-display text-xl uppercase tracking-tight">{r.clasa}</span>
                <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase">NE 12/99</span>
              </div>
              <dl className="grid grid-cols-2 gap-px bg-black/10">
                <Cell label="Marcă" value={r.marca} />
                <Cell label="Clasă C140-86" value={r.bc} />
                <Cell label="Fck cilindru" value={`${r.fckCil} N/mm²`} />
                <Cell label="Fck cub" value={`${r.fckCub} N/mm²`} />
              </dl>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <a
            href="tel:0766693105"
            data-testid="services-call-fetesti"
            className="btn-amber rounded-sm inline-flex items-center gap-2 px-5 py-3.5 text-sm font-bold uppercase tracking-wider"
          >
            <span className="text-[10px] tracking-[0.2em] opacity-70">FETEȘTI</span>
            <span>· 0766 693 105</span>
          </a>
          <a
            href="tel:0722569492"
            data-testid="services-call-slobozia"
            className="btn-ink rounded-sm inline-flex items-center gap-2 px-5 py-3.5 text-sm font-bold uppercase tracking-wider"
          >
            <span className="text-[10px] tracking-[0.2em] opacity-70 text-[#F59E0B]">SLOBOZIA</span>
            <span>· 0722 569 492</span>
          </a>
          <span className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-neutral-500">
            Disponibilitate confirmată telefonic
          </span>
        </div>

        {/* Produse certificate suplimentar */}
        <div className="mt-20 sm:mt-24" data-testid="certified-products">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-8 h-px bg-[#0A0A0A]" />
            <span className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-neutral-700">
              Produse certificate · Lucrări rutiere & drumuri
            </span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Beton Rutier */}
            <div data-testid="product-beton-rutier" className="bg-white border border-black/15 p-6 sm:p-8">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[#F59E0B]">
                    Produs · 01
                  </div>
                  <div className="font-display text-3xl sm:text-4xl uppercase tracking-tight leading-none mt-3">
                    Beton Rutier
                  </div>
                </div>
                <div className="bg-[#0A0A0A] text-white font-mono-tech text-[10px] tracking-[0.2em] uppercase px-3 py-1.5">
                  Certificat
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-black/10">
                <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-500 mb-3">
                  Clase disponibile
                </div>
                <div className="flex flex-wrap gap-2">
                  {["BcR 3.5", "BcR 4", "BcR 4.5", "BcR 5"].map((c) => (
                    <span
                      key={c}
                      className="font-display text-lg uppercase tracking-tight px-3 py-1.5 bg-[#FFF7E6] border border-[#F59E0B]/40 text-black"
                    >
                      {c}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-black/10">
                <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-500 mb-2">
                  Utilizare preconizată
                </div>
                <p className="text-sm sm:text-base text-neutral-700 leading-relaxed">
                  Executarea îmbrăcămințiilor rutiere din beton de ciment, în sistemele cofraje fixe și glisante.
                </p>
              </div>
            </div>

            {/* Agregate Stabilizate cu Ciment */}
            <div data-testid="product-agregate" className="bg-[#0A0A0A] text-white p-6 sm:p-8">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[#F59E0B]">
                    Produs · 02
                  </div>
                  <div className="font-display text-3xl sm:text-4xl uppercase tracking-tight leading-none mt-3">
                    Agregate<br />Stabilizate cu Ciment
                  </div>
                </div>
                <div className="bg-[#F59E0B] text-black font-mono-tech text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 font-bold">
                  Certificat
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-white/15">
                <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-400 mb-3">
                  Tipuri disponibile
                </div>
                <div className="flex flex-wrap gap-2">
                  {["4%", "5%", "6%"].map((c) => (
                    <span
                      key={c}
                      className="font-display text-lg uppercase tracking-tight px-3 py-1.5 bg-white/5 border border-white/20 text-white"
                    >
                      Tip {c}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-white/15">
                <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-400 mb-2">
                  Utilizare preconizată
                </div>
                <p className="text-sm sm:text-base text-neutral-300 leading-relaxed">
                  Lucrări de drumuri — strat de fundație / bază stabilizat cu ciment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Th({ children, highlight }) {
  return (
    <th
      className={`text-left px-5 py-4 font-mono-tech text-[11px] tracking-[0.15em] uppercase border-r border-white/10 last:border-r-0 ${
        highlight ? "bg-[#F59E0B] text-black" : ""
      }`}
    >
      {children}
    </th>
  );
}

function Td({ children, highlight, mono }) {
  return (
    <td
      className={`px-5 py-4 border-r border-black/10 last:border-r-0 ${
        highlight
          ? "font-display text-xl tracking-tight uppercase text-black bg-[#FFF7E6]"
          : mono
          ? "font-mono-tech text-sm text-neutral-800"
          : "font-mono-tech text-sm text-neutral-700"
      }`}
    >
      {children}
    </td>
  );
}

function Cell({ label, value }) {
  return (
    <div className="bg-white px-4 py-3">
      <div className="font-mono-tech text-[9px] tracking-[0.2em] uppercase text-neutral-500">{label}</div>
      <div className="font-mono-tech text-sm text-black mt-1">{value}</div>
    </div>
  );
}
